// extracted by mini-css-extract-plugin
export default {"subtitle":"J+xE-","noBottomMargin":"z-tOt"};